import request from '@/modules/base/util/request'
import config from '@/config'

const baseUrl = `${config.resourceHost}import`

export const IMPORT_TYPE_CUSTOMERS = 'customers'
export const IMPORT_TYPE_SUPPLIERS = 'suppliers'
export const IMPORT_TYPE_ARTICLES = 'articles'
export const IMPORT_TYPE_ARTICLES_MASS = 'articlesMass'
export const IMPORT_TYPE_CUSTOMERS_MASS = 'customersMass'
export const IMPORT_TYPE_SUPPLIERS_MASS = 'suppliersMass'

export const MassImportService = {
  getImportSchema: (type) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}/${type}/schema`, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  postArticleMassImport: (data) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}/articles/mass`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  postCustomerMassImport: (data) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}/customers/mass`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  postSupplierMassImport: (data) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}/suppliers/mass`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
}
